export enum DocumentRedactInfoType {
    REDACT = 'REDACT',
}

export interface DocumentRedactInfo {
    _id?: string;
    type: DocumentRedactInfoType;
    documentId: string;
    page: number;
    start: [number, number];
    end: [number, number];
    manual: boolean;
    createdAt: Date;
    createdBy: string;
}

export type DocumentRedactInfoCreation = Omit<DocumentRedactInfo, 'createdAt' | 'type' | 'manual' | 'createdBy' | '_id'>;
